export type TExamTab = {
  id: string
  sectionId: string
  label: string
  name: string
}

export const EXAM_STAGE_TAB = {
  FULL_RESERVATION: 'full-reservation',
  REAL_TIME_RESTORE: 'real-time-restore',
  EXAM_REVIEW: 'exam-review',
  EXAM_VOTE: 'exam-vote',
  PREDICTION_SCORE: 'prediction-score',
}

export const EXAM_STAGE_TAB_SECTION = {
  FULL_RESERVATION: 'section1',
  REAL_TIME_RESTORE: 'section2',
  EXAM_REVIEW: 'section2',
  EXAM_VOTE: 'section2',
  PREDICTION_SCORE: 'section2',
}

export const EXAM_TAB_OPTIONS: Array<TExamTab> = [
  {
    id: EXAM_STAGE_TAB.FULL_RESERVATION,
    sectionId: EXAM_STAGE_TAB_SECTION.FULL_RESERVATION,
    label: 'STEP 1',
    name: '풀서비스 사전예약',
  },
  {
    id: EXAM_STAGE_TAB.REAL_TIME_RESTORE,
    sectionId: EXAM_STAGE_TAB_SECTION.REAL_TIME_RESTORE,
    label: 'STEP 2',
    name: '실시간 기출복원',
  },
  {
    id: EXAM_STAGE_TAB.EXAM_REVIEW,
    sectionId: EXAM_STAGE_TAB_SECTION.EXAM_REVIEW,
    label: 'STEP 3',
    name: 'GSAT 응시후기',
  },
  {
    id: EXAM_STAGE_TAB.EXAM_VOTE,
    sectionId: EXAM_STAGE_TAB_SECTION.EXAM_VOTE,
    label: 'STEP 4',
    name: 'GSAT 난이도투표',
  },
  {
    id: EXAM_STAGE_TAB.PREDICTION_SCORE,
    sectionId: EXAM_STAGE_TAB_SECTION.PREDICTION_SCORE,
    label: 'STEP 5',
    name: '가채점&합격예측',
  },
]

export const EXAM_TAB_OPTIONS_MOBILE: Array<TExamTab> = [
  {
    id: EXAM_STAGE_TAB.FULL_RESERVATION,
    sectionId: EXAM_STAGE_TAB_SECTION.FULL_RESERVATION,
    label: 'STEP 1',
    name: '풀서비스\n사전예약',
  },
  {
    id: EXAM_STAGE_TAB.REAL_TIME_RESTORE,
    sectionId: EXAM_STAGE_TAB_SECTION.REAL_TIME_RESTORE,
    label: 'STEP 2',
    name: '실시간\n기출복원',
  },
  {
    id: EXAM_STAGE_TAB.EXAM_REVIEW,
    sectionId: EXAM_STAGE_TAB_SECTION.EXAM_REVIEW,
    label: 'STEP 3',
    name: 'GSAT\n응시후기',
  },
  {
    id: EXAM_STAGE_TAB.EXAM_VOTE,
    sectionId: EXAM_STAGE_TAB_SECTION.EXAM_VOTE,
    label: 'STEP 4',
    name: 'GSAT\n난이도\n투표',
  },
  {
    id: EXAM_STAGE_TAB.PREDICTION_SCORE,
    sectionId: EXAM_STAGE_TAB_SECTION.PREDICTION_SCORE,
    label: 'STEP 5',
    name: 'GSAT\n가채점&\n합격예측',
  },
]

export const GSAT_2025_TAB_OPTIONS_MOBILE: Array<TExamTab> = [
  {
    id: EXAM_STAGE_TAB.FULL_RESERVATION,
    sectionId: EXAM_STAGE_TAB_SECTION.FULL_RESERVATION,
    label: 'STEP 1',
    name: '풀서비스\n사전예약',
  },
  {
    id: EXAM_STAGE_TAB.REAL_TIME_RESTORE,
    sectionId: EXAM_STAGE_TAB_SECTION.REAL_TIME_RESTORE,
    label: 'STEP 2',
    name: '실시간\n기출복원',
  },
  {
    id: EXAM_STAGE_TAB.EXAM_REVIEW,
    sectionId: EXAM_STAGE_TAB_SECTION.EXAM_REVIEW,
    label: 'STEP 3',
    name: 'GSAT\n응시후기',
  },
  {
    id: EXAM_STAGE_TAB.EXAM_VOTE,
    sectionId: EXAM_STAGE_TAB_SECTION.EXAM_VOTE,
    label: 'STEP 4',
    name: 'GSAT\n난이도 투표',
  },
  {
    id: EXAM_STAGE_TAB.PREDICTION_SCORE,
    sectionId: EXAM_STAGE_TAB_SECTION.PREDICTION_SCORE,
    label: 'STEP 5',
    name: '가채점&\n합격예측',
  },
]
